// This file is updated using the cli
// No not modify!
import React from 'react';
const Icon = (props) => {
    return (React.createElement("svg", Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 5 9", width: "5", height: "9" }, props),
        React.createElement("g", { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
            React.createElement("g", { transform: "translate(-401 -334)" },
                React.createElement("path", { d: "M401 343 401 334 406 338.5z" })))));
};
Icon.displayName = 'CaretRight5x9';
export default Icon;
//# sourceMappingURL=CaretRight5x9.js.map